import { MutationCache, QueryCache } from '@tanstack/react-query';
import { extractErrorMessage } from './extractErrorMessage';

type PushErrorRef = { current: (message: string) => void };

export function createQueryClientCaches(pushErrorRef: PushErrorRef) {
  return {
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query.meta?.errorMessage) {
          const customMessage =
            typeof query.meta.errorMessage === 'string'
              ? query.meta.errorMessage
              : undefined;
          const { message } = extractErrorMessage(error);
          pushErrorRef.current(customMessage ?? message);
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (mutation.meta?.skipGlobalErrorToast) return;
        const customMessage =
          typeof mutation.meta?.errorMessage === 'string'
            ? mutation.meta.errorMessage
            : undefined;
        const { message } = extractErrorMessage(error);
        pushErrorRef.current(customMessage ?? message);
      },
    }),
  };
}
